import { combineReducers } from 'redux';

import { actions } from '../actions/navigation';

const isOpen = (state = false, action) => {
  switch (action.type) {
    case '@@router/ON_LOCATION_CHANGED':
      return false;
    case actions.NAVIGATION_TOGGLE_OPEN:
      return !state;
    default: 
      return state;
  }
}

const header = (state = 'default', action) => {
  switch(action.type) {
    case actions.HEADER_CHANGE_TYPE:
      return action.payload.type;
    default:
      return state;
  }
};

const navigation = combineReducers({
  isOpen,
  header,
});

export default navigation;

export const isNavigationOpenSelector = (state) => state.navigation.isOpen;

export const headerTypeSelector = (state) => state.navigation.header;
